
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Features from './Features';
import FAQ from './FAQ';
import Demo from './Demo';
import Privacy from './Privacy';
import PrivacyIos from './PrivacyIos';
import HowToEQ from './HowToEQ';
import Terms from './Terms';
import TermsIos from './TermsIos';
import logo from './assets/spoteq_logo.png';

const App: React.FC = () => {
  const [theme, setTheme] = useState<'light' | 'dark'>('dark');

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    document.body.style.backgroundColor = theme === 'dark' ? '#121212' : '#ffffff';
    document.body.style.color = theme === 'dark' ? '#ffffff' : '#000000';
    document.documentElement.style.backgroundColor = theme === 'dark' ? '#121212' : '#ffffff';
  }, [theme]);

  // Update favicon dynamically to use the app logo
  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (favicon) {
      favicon.href = logo;
    } else {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = logo;
      document.head.appendChild(link);
    }
  }, []);

  return (
    <Router>
      <div className={`App ${theme}`} style={{ minHeight: '100vh' }}>
        <Navbar theme={theme} toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<Home theme={theme} />} />
          <Route path="/features" element={<Features theme={theme} />} />
          <Route path="/demo" element={<Demo theme={theme} />} />
          <Route path="/how-to-eq" element={<HowToEQ theme={theme} />} />
          <Route path="/faq" element={<FAQ theme={theme} />} />
          <Route path="/about" element={<About theme={theme} />} />
          <Route path="/privacy" element={<Privacy theme={theme} />} />
          <Route path="/privacyios" element={<PrivacyIos theme={theme} />} />
          <Route path="/terms" element={<Terms theme={theme} />} />
          <Route path="/termsios" element={<TermsIos theme={theme} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;